import { Injectable } from "@angular/core";
import { CoreHttpClient } from "@obg/ngx.core";
import { Observable } from "rxjs";

import { SuspiciousLoginConfigService } from "./suspicious-login.config";
import { SuspiciousLoginPinRequest } from "./suspicious-login.model";

@Injectable({
	providedIn: "root",
})
export class SuspiciousLoginService {
	constructor(
		private httpClient: CoreHttpClient,
		private config: SuspiciousLoginConfigService
	) {}

	requestPin(request: SuspiciousLoginPinRequest): Observable<object> {
		return this.httpClient.post<SuspiciousLoginPinRequest>({
			url: this.config.getRequestPinEndpoint(),
			data: request,
		});
	}
}
